<div *ngIf="!getSessionExpired" class="card">
  <div class="text-center">
    <button class="btn btn-outline-primary m-3" [class.active]="page === 'View'" (click)="changePage('View')">Преглед на
      трансакците</button>
    <button class="btn btn-outline-success m-3" [class.active]="page === 'Add'" (click)="changePage('Add')">Добавяне на
      нова трансакция</button>
  </div>
  <div class="card-body" *ngIf="page == 'Add'">
    <div class="row-lg mt-1" *ngFor="let transaction of m.controls; let i = index">
      <form [formGroup]="transaction" (ngSubmit)="addItem(i)">
        <div class="form-group">
          <label class="pt-2">Име на трансакцията: </label>
          <input class="form-control" type="text" formControlName="name" placeholder="Пазаруване в Кауфланд" />

          <label class="pt-2">Стойност: </label>
          <input class="form-control" type='number' min=".01" formControlName="amount" placeholder="147.59" />

          <label class="pt-2">Дата: </label>
          <input class="form-control" type="date" formControlName="date" />

          <label class="pt-2">Тип: </label>
          <input class="form-control" type="text" formControlName="type"
            placeholder="Приход, Разход, Непредведен разход и др." />

          <div class="row text-danger mt-2 pl-3" *ngIf="transaction.invalid">Моля попълнете задължителните полета!
          </div>
          <div class="row mt-2 pl-3">
            <button type="submit" class="btn btn btn-success">Добави</button>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="notification != null && notification != undefined">

      <div *ngIf="notification.isValid" class="alert alert-success alert-dismissible fade show" role="alert">
        {{notification.message}}
        <button (click)="clearNotification()" type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div *ngIf="!notification.isValid" class="alert alert-warning alert-dismissible fade show" role="alert">
        {{notification.message}}
        <button (click)="clearNotification()" type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>

  <app-view-transactions *ngIf="page == 'View'"></app-view-transactions>
</div>

<app-calculator></app-calculator>

<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h3>За нас</h3>
        <p>Ние в My Lev сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да има
          контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да получите подробна
          информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
      </div>
      <div class="col-md-3">
        <h3>За връзка</h3>
        <ul>
          <li>Димитър Найденов 100</li>
          <li>Велико Търново, България</li>
          <li>Email: info@mylev.com</li>
        </ul>
      </div>
      <div class="col-md-3">
        <h3>Последвайте ни в</h3>
        <ul>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Instagram</a></li>
          <li><a href="#">LinkedIn</a></li>
        </ul>
      </div>
    </div>
    <hr>
    <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MY LEV 2023</p>
  </div>
</footer>